import {AuthorizationError} from "@app/core/shared/domain/authoritzation.error";
import {InfrastructureError, InfrastructureErrorType} from "@app/core/shared/domain/infrastructure.error";
import {PopupMessage, PopupMessageType} from "@app/presentation/components/errors/popup.message";
import {NavigationAction, NavigationActionPage} from "@app/core/shared/domain/entities/navigation-action";

export class ErrorsManager {

    manageErrors(error: Error): PopupMessage | NavigationAction {
        if (error instanceof InfrastructureError) {
            return this.manageInfrastructureError(error)
        } else if (error instanceof AuthorizationError) {
            return this.manageAuthorizationError(error)
        } else {
            return this.manageUseCaseError(error)
        }
    }

    protected manageInfrastructureError(error: InfrastructureError): PopupMessage | NavigationAction {

        let errType = error.type

        switch (errType) {
            case InfrastructureErrorType.ConnectionError:
                return this.manageConnectionError()

            case InfrastructureErrorType.InternalServerError:
                return this.manageInternalServerError()

            case InfrastructureErrorType.TimeOutError:
                return this.manageTimeOutError()

            case InfrastructureErrorType.BackendError:
                return this.manageBackendError(error)
            case InfrastructureErrorType.ServiceUnavailableError:
                return this.manageServiceUnavailableError(error)
        }
    }

    // ----------------------------------------------------------------------------
    //TODO: els missatges d'error per defecte s'haurien de traduir

    protected manageAuthorizationError(error: AuthorizationError): PopupMessage {
        let type = PopupMessageType.ErrorAlert
        let message = error.apiError?.message || "Usuario no autorizado, comprueba el nombre de usuario y contraseña y vuelve a iniciar la sesión."
        return new PopupMessage(message, type)
    }

    protected manageConnectionError(): PopupMessage {

        let type = PopupMessageType.SnackBar
        let message = "No se ha podido establecer conexion con el servidor, intentelo más tarde."

        return new PopupMessage(message, type)
    }

    protected manageTimeOutError(): PopupMessage {

        let type = PopupMessageType.SnackBar
        let message = "El servidor esta tardando demasiado en responder, intentelo más tarde."

        return new PopupMessage(message, type)
    }

    protected manageInternalServerError(): PopupMessage {
        let type = PopupMessageType.ErrorAlert
        let message = "¡Algo salió mal! Por favor intentalo de nuevo."

        return new PopupMessage(message, type)
    }

    protected manageBackendError(error: InfrastructureError): PopupMessage {
        let type = PopupMessageType.ErrorAlert
        let apiError = error.apiError
        let message = "¡Algo salió mal! Por favor intentalo de nuevo."
        if (apiError != null) {
            message = apiError.message
        }

        return new PopupMessage(message, type)
    }

    protected manageUseCaseError(error: Error): PopupMessage {
        return this.manageInternalServerError()
    }

    private manageServiceUnavailableError(error: InfrastructureError) {
        return new NavigationAction(NavigationActionPage.SERVICE_UNAVAILABLE)
    }
}
